import { useFormikContext } from "formik";

export const AllErrors = () => {
  // this is hear because we're not yet surfacing all the possible errors.
  const { errors } = useFormikContext();
  if (Object.keys(errors).length > 0) {
    console.log("FORMIK ERRORS", errors);
  }
  return null;
};
